import { UserGroupEnum } from 'videoservice-openapi-react';
import { EColorsNames } from 'shared/types/theme';

export const Role2BadgeMap: Record<UserGroupEnum, EColorsNames> = {
  [UserGroupEnum.ADMIN]: EColorsNames.Red,
  [UserGroupEnum.OPERATOR]: EColorsNames.Yellow,
  [UserGroupEnum.CUSTOMER]: EColorsNames.Blue,
};
